import styled from 'styled-components';


/*
========================================
FONDO
========================================
*/

export const FondoModalInvitacion =
    styled.div`

    position:
        fixed;

    inset:
        0;

    z-index:
        2000;

    display:
        flex;

    align-items:
        center;

    justify-content:
        center;

    box-sizing:
        border-box;

    padding:
        1.2rem;

    background-color:
        rgba(
            43,
            43,
            43,
            0.46
        );
`;


/*
========================================
MODAL
========================================
*/

export const ModalInvitacion =
    styled.div`

    width:
        min(
            100%,
            560px
        );

    max-height:
        calc(
            100vh - 2.4rem
        );

    overflow-y:
        auto;

    box-sizing:
        border-box;

    padding:
        1.7rem
        1.8rem;

    border:
        1.5px solid
        #69BEB8;

    border-radius:
        20px;

    background-color:
        #FFFFFF;

    box-shadow:
        0
        18px
        50px
        rgba(
            0,
            0,
            0,
            0.18
        );


    @media (max-width: 600px) {

        padding:
            1.3rem
            1.1rem;
    }
`;


/*
========================================
ENCABEZADO
========================================
*/

export const EncabezadoModalInvitacion =
    styled.div`

    display:
        flex;

    align-items:
        center;

    justify-content:
        space-between;

    gap:
        1rem;

    margin-bottom:
        1.2rem;
`;


export const TituloModalInvitacion =
    styled.h2`

    margin:
        0;

    font-size:
        1.15rem;

    font-weight:
        800;

    color:
        #23AAAF;
`;


export const BotonCerrarModalInvitacion =
    styled.button`

    width:
        30px;

    height:
        30px;

    min-width:
        30px;

    display:
        flex;

    align-items:
        center;

    justify-content:
        center;

    padding:
        0;

    border:
        none;

    border-radius:
        50%;

    background-color:
        transparent;

    color:
        #646464;

    font-size:
        1.3rem;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        background-color:
            #F3FAFA;

        color:
            #23AAAF;
    }


    &:disabled {

        opacity:
            0.45;

        cursor:
            not-allowed;
    }
`;


/*
========================================
TEXTOS
========================================
*/

export const TextoModalInvitacion =
    styled.p`

    margin:
        0
        0
        1rem
        0;

    font-size:
        0.86rem;

    line-height:
        1.55;

    color:
        #646464;
`;


/*
========================================
EMAIL
========================================
*/

export const BloqueEmailInvitacion =
    styled.div`

    box-sizing:
        border-box;

    margin-bottom:
        1rem;

    padding:
        0.85rem
        1rem;

    border:
        1px solid
        #B8DEDC;

    border-radius:
        10px;

    background-color:
        #F3FAFA;

    font-size:
        0.8rem;

    color:
        #646464;
`;


export const EmailInvitacion =
    styled.div`

    margin-top:
        0.25rem;

    font-size:
        0.9rem;

    font-weight:
        800;

    color:
        #2B2B2B;

    overflow-wrap:
        anywhere;
`;


/*
========================================
AVISO
========================================
*/

export const AvisoModalInvitacion =
    styled.div`

    box-sizing:
        border-box;

    margin:
        0.3rem
        0
        1rem
        0;

    padding:
        0.85rem
        1rem;

    border-left:
        4px solid
        #655EE8;

    border-radius:
        8px;

    background-color:
        #F7F6FE;

    font-size:
        0.8rem;

    line-height:
        1.5;

    color:
        #514BBE;


    strong {

        font-weight:
            800;
    }
`;


/*
========================================
ERROR
========================================
*/

export const ErrorModalInvitacion =
    styled.div`

    box-sizing:
        border-box;

    margin:
        1rem
        0;

    padding:
        0.8rem
        1rem;

    border:
        1.5px solid
        #E7973C;

    border-radius:
        10px;

    background-color:
        #FFF4E8;

    font-size:
        0.78rem;

    font-weight:
        700;

    line-height:
        1.45;

    color:
        #C96F1B;
`;


/*
========================================
ACCIONES
========================================
*/

export const AccionesModalInvitacion =
    styled.div`

    display:
        flex;

    align-items:
        center;

    justify-content:
        flex-end;

    gap:
        0.7rem;

    margin-top:
        1.4rem;


    @media (max-width: 500px) {

        flex-direction:
            column-reverse;

        align-items:
            stretch;
    }
`;


export const BotonCancelarInvitacion =
    styled.button`

    min-height:
        38px;

    box-sizing:
        border-box;

    padding:
        0.55rem
        1rem;

    border:
        1px solid
        #BEBEBE;

    border-radius:
        9px;

    background-color:
        #FFFFFF;

    color:
        #646464;

    font-family:
        inherit;

    font-size:
        0.8rem;

    font-weight:
        700;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        background-color:
            #F5F5F5;
    }


    &:disabled {

        opacity:
            0.5;

        cursor:
            not-allowed;
    }
`;


export const BotonConfirmarInvitacion =
    styled.button`

    min-height:
        38px;

    box-sizing:
        border-box;

    padding:
        0.55rem
        1.15rem;

    border:
        none;

    border-radius:
        9px;

    background-color:
        #FC8906;

    color:
        #FFFFFF;

    font-family:
        inherit;

    font-size:
        0.8rem;

    font-weight:
        800;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        opacity:
            0.9;
    }


    &:disabled {

        opacity:
            0.55;

        cursor:
            not-allowed;
    }
`;